import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Container } from '@pixi/react';
import { Assets } from 'pixi.js';
import { useMemo } from 'react';
import { useAppSelector } from '../../../redux/store';
import { InternalAnimatedSprite } from '../pixiComponents/internalAnimatedSprite';
const ARROW_TO_AVATAR_SIZE_RATIO = 0.4;
export const ActionArrow = () => {
    const roughAvatarSizePx = useAppSelector((state) => state.gameDimensions.roughAvatarSizePx);
    const textures = useMemo(() => {
        const spritesheet = Assets.get('action-arrow');
        return spritesheet?.animations.PokerActionArrow;
    }, []);
    if (!textures) {
        return null;
    }
    if (!roughAvatarSizePx) {
        return null;
    }
    // action arrow is sized relative to the size of the avatar:
    const scale = (roughAvatarSizePx * ARROW_TO_AVATAR_SIZE_RATIO) / textures[0].width;
    return (_jsx(Container, { scale: scale, children: _jsx(InternalAnimatedSprite, { textures: textures, animationSpeed: 0.5, loop: true }) }));
};
